import { render, staticRenderFns } from "./MarkDown.vue?vue&type=template&id=5f6b715f"
import script from "./MarkDown.vue?vue&type=script&lang=js"
export * from "./MarkDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports